import jQuery from 'jquery';

( function( win, doc, $ ) {

    const $playvideo_button = $( '[data-playvideo]' ),
          flexbackground_video_el = $playvideo_button.parents('.flexbackground').find('.flexbackground__video').get(0),
          $close_button = $(flexbackground_video_el).prev('.flexbackground__close-video-button');


    $playvideo_button.on( 'click', function() {
        
        if ( flexbackground_video_el.querySelector('source').hasAttribute('src') ) {

            flexbackground_video_el.play();

            $(flexbackground_video_el).parents('.flexbackground').find('.flexbackground__content').animate({
                opacity: 0
            }, 200);

            $close_button.fadeIn(200);            
        }

    } );

    $close_button.on( 'click', function() {

        flexbackground_video_el.pause();

        $(flexbackground_video_el).parents('.flexbackground').find('.flexbackground__content').animate({
            opacity: 1
        }, 200);

        $(this).fadeOut(200);

    } );

} )( window, document, jQuery );